import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';

// Layout Modules
import { CommonLayoutComponent } from './common/common-layout.component';
import { AuthenticationLayoutComponent } from './common/authentication-layout.component';

// Directives
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Sidebar_Directives } from './shared/directives/side-nav.directive';

// Routing Module
import { AppRoutes, AppRoutesModule } from './app.routing';

// App Component
import { AppComponent } from './app.component';
import { AuthGuard } from './modules/authentication/auth.guard';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { SharedModule } from './shared.module';

import { ToastrComponent } from './common/toastr/toast.component';
import { HandleErrorsInterceptors } from './shared/interceptors/HandleErrorsInterceptors';
import { AcceptLanguageInterceptor } from './shared/interceptors/accept-language.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PrivacyLayoutComponent } from './common/privacy/common-privacy.component';
import { HomeComponent } from './modules/authentication/home/home.component';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { DataTablesModule } from 'angular-datatables';
import { SideNavComponent } from './common/side-nav/side-nav.component';
import { NoAccessComponent } from './modules/authentication/no-access/no-access.component';

class TranslateHttpLoader implements TranslateLoader {
    constructor(private http: HttpClient,
        public prefix: string = '../assets/i18n/',
        public suffix: string = '.json',
        public cacheBustValue: string = '16') {
    }

    public getTranslation(lang: string): Observable<Object> {
        if (!lang) {
            debugger;
        }
        return this.http.get(`${this.prefix}${lang}${this.suffix}?cachebust=${this.cacheBustValue}`).pipe(
            catchError(_ => of({}))
        );
    }
}

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http);
}
@NgModule({
    imports: [
        BrowserModule,
        AppRoutesModule,
        DataTablesModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(AppRoutes, { useHash: true }),
        NgbModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        }),
        SharedModule
    ],
    declarations: [
        AppComponent,
        CommonLayoutComponent,
        PrivacyLayoutComponent,
        AuthenticationLayoutComponent,
        ToastrComponent,
        Sidebar_Directives,
        HomeComponent,
		SideNavComponent,
		NoAccessComponent
    ],
    providers: [
        AuthGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HandleErrorsInterceptors,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AcceptLanguageInterceptor,
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
